module.exports = __webpack_public_path__ + "img/604_2.c76c5764.jpg";